import { Tabs } from '@/components';
import type { FC } from 'react';

type Props = {
  selectedYear: number;
  fiscalYears: number[];
  onSelect: (selectedYear: number) => void;
  /** タブのラベル変換。デフォルトは年度の文字列表現 */
  getLabel?: (year: number) => string;
};

export const GraphYearSelectorTabs: FC<Props> = ({
  selectedYear,
  fiscalYears,
  onSelect,
  getLabel,
}) => {
  const yearTabItems = Array.from(new Set(fiscalYears))
    .sort((a, b) => (a < b ? -1 : 1))
    .map((year) => {
      const yearString = year.toString();
      return {
        key: yearString,
        label: getLabel ? getLabel(year) : yearString,
      };
    });

  return (
    <Tabs
      activeKey={selectedYear.toString()}
      type="line"
      size="small"
      onChange={(activeKey) => {
        onSelect(Number(activeKey));
      }}
      items={yearTabItems}
    />
  );
};
